import { ApiResponse, clientsBaseUrl, getData } from "@Services/constServices";

export const getSearchClientReniec = async (
  documentNumber: string
): Promise<ApiResponse> => {
  const url = `${clientsBaseUrl}/reniec?documentNumber=${documentNumber}`;
  return getData(url);
};
